import {Action} from '@ngrx/store';
import {AlarmEvent} from '../../shared/models/alarm';

export const ALARMS_ACTIVE_EVENTS_FETCHED = '[Alarms] active events fetched';
export const ALARMS_EVENT_FETCHED = '[Alarms] event fetched';
export const ALARMS_EVENT_ACKNOWLEDGED = '[Alarms] event acknowledged';
export const ALARMS_EVENT_CLEARED = '[Alarms] event cleared';

export class AlarmsActiveEventsFetched implements Action {
  readonly type = ALARMS_ACTIVE_EVENTS_FETCHED;


  constructor(public events: AlarmEvent[]) {
  }
}

export class AlarmsEventFetched implements Action {
  readonly type = ALARMS_EVENT_FETCHED;


  constructor(public event: AlarmEvent) {
  }
}

export class AlarmsEventAcknowledged implements Action {
  readonly type = ALARMS_EVENT_ACKNOWLEDGED;


  /**
   *
   * @param event {AlarmEvent} Should be the event as returned by the server after acknowledgment
   */
  constructor(public event: AlarmEvent) {
  }
}

export class AlarmsEventCleared implements Action {
  readonly type = ALARMS_EVENT_CLEARED;


  /**
   *
   * @param event {AlarmEvent} Should be the event as returned by the server after clearance
   */
  constructor(public event: AlarmEvent) {
  }
}

export type Actions = AlarmsActiveEventsFetched
  | AlarmsEventFetched
  | AlarmsEventAcknowledged
  | AlarmsEventCleared;
